// @flow

export default class Waveform {
  waveformLayout: Array<Array<number>> = {
    name: 'twelvePlusOne',
    obj: [0, 3, 6, 9, 1, 4, 7, 10, 2, 5, 8, 11, 1],
  }; // 12+1 default layout

  htmlElements: Array<Object> = [];

  parentSize: Object = { width: 1, height: 1, left: 1, top: 1 }; // random initial numbers

  waveformLayoutViewIndex: number = 0;

  scaleFactor: number = 1;

  timeFactor: number = 1;
}
